import React from "react";

import exo_cargo from "assets/img/hyperdrive/exo-cargo.png";
import quad_cargo from "assets/img/hyperdrive/quad-cargo.png";
import lrhs_cargo from "assets/img/hyperdrive/lrhs-cargo.png";

const CargoDrones = ({isMobile}) => {
  return (
    <>
      <div style={{ textAlign: 'center' }}>
        { /* Title */ }
        <h3 className="title" style={{ lineHeight: "150%", fontSize: '2.25em', marginTop: '20px' }}>Heavy Lift Cargo Drones</h3>

        { /* Images */ }
        <div id="use-cases-section" className="d-flex flex-md-row flex-column justify-content-center align-items-center" style={{ marginTop: '20px'}}>
          {/* ExoCargo */}
          <div className="text-center mb-4 mb-md-0" style={{ width: '300px' }}>
            <img src={exo_cargo} style={{width:'80%'}} alt="exoCargo" />
            <h4 style={{ color: 'white' }}>exoCargo<br/></h4>
            <p style={{ color: 'white', padding:'20px' }}>
              <b>Payload Weight:</b> 250-500 lbs
              <br/>
              <b>Payload Size:</b> 1 Pallet
              <br/>
              <b>Max Range:</b> 40-60 miles
              <br/>
              <b>Max Speed:</b> 60 MPH
              <br/>
              <b>Max Noise:</b> &lt;50 dBA
              <br/>
              <b>Footprint:</b> &lt;9 ft
            </p>
          </div>
          {/* Quad Cargo */}
          <div className="text-center mb-4 mb-md-0" style={{ width: '300px' }}>
            <img src={quad_cargo} style={{width:'75%'}} alt="Quad Cargo" />
            <h4 style={{ color: 'white' }}><br/>Quad Cargo<br/></h4>
            <p style={{ color: 'white', padding:'20px' }}>
              <b>Payload Weight:</b> 500-750 lbs
              <br/>
              <b>Payload Size:</b> 2 Pallets
              <br/>
              <b>Max Range:</b> 40-60 miles
              <br/>
              <b>Max Speed:</b> 60 MPH
              <br/>
              <b>Max Noise:</b> &lt;55 dBA
              <br/>
              <b>Footprint:</b> &lt;18 ft x 7.5 ft
            </p>
          </div>
          {/* LRHS Cargo */}
          <div className="text-center mb-4 mb-md-0" style={{ width: '300px' }}>
            <img src={lrhs_cargo} style={{width:'90%'}} alt="Long Range, High Speed, Blended Wing Body" />
            <h5 style={{ color: 'white' }}><br/>Long Range High Speed<br/>Blended Wing Body</h5>
            <p style={{ color: 'white', padding:'20px'  }}>
              <b>Payload Weight:</b> 750 lbs
              <br/>
              <b>Payload Size:</b> 3 Pallets
              <br/>
              <b>Max Range:</b> 400 miles
              <br/>
              <b>Max Speed:</b> 400 MPH
              <br/>
              <b>Max Noise:</b> &lt;60 dBA
              <br/>
              <b>Wingspan:</b> 32 ft wingspan
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CargoDrones;
